__turbopack_context__.v({
  "className": "geist_82ab5c55-module__LPSr-q__className",
  "variable": "geist_82ab5c55-module__LPSr-q__variable",
});
